// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1-3Kk","signatureButtonsRight":"ModalSign_signatureButtonsRight__DJgiD"};